import { render, staticRenderFns } from "./ClubDiscountSwitch.vue?vue&type=template&id=2edc75c8&scoped=true&"
import script from "./ClubDiscountSwitch.vue?vue&type=script&lang=js&"
export * from "./ClubDiscountSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ClubDiscountSwitch.vue?vue&type=style&index=0&id=2edc75c8&lang=scss&scoped=true&"
import style1 from "./ClubDiscountSwitch.vue?vue&type=style&index=1&id=2edc75c8&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edc75c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2edc75c8')) {
      api.createRecord('2edc75c8', component.options)
    } else {
      api.reload('2edc75c8', component.options)
    }
    module.hot.accept("./ClubDiscountSwitch.vue?vue&type=template&id=2edc75c8&scoped=true&", function () {
      api.rerender('2edc75c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/core/ClubDiscount/components/common/ClubDiscountSwitch.vue"
export default component.exports